// Simplified configuration - build-time only
// API calls are hardcoded to /api (handled by Vite proxy in dev, ingress in prod)

// Cesium Ion token for 3D globe
export const CESIUM_ION_TOKEN = import.meta.env.VITE_CESIUM_ION_TOKEN || ''

// Document storage path prefix
export const DOCUMENT_PATH_PREFIX = import.meta.env.VITE_DOCUMENT_PATH_PREFIX || ''

// Authentication provider. 'password' = built-in username/password form.
// 'oidc' = redirect-based PKCE login via Keycloak (react-oidc-context).
export type AuthProviderKind = 'password' | 'oidc'
export const AUTH_PROVIDER: AuthProviderKind =
  (import.meta.env.VITE_AUTH_PROVIDER as AuthProviderKind) || 'password'
// Under SSO the IdP owns the user directory: accounts appear on first login (JIT)
// and credentials live there, so local creation/password reset are unavailable.
// Mirrors the API's `auth_provider == "keycloak"`, which enforces it.
export const IDP_MANAGES_ACCOUNTS = AUTH_PROVIDER === 'oidc'
export const OIDC_AUTHORITY = import.meta.env.VITE_OIDC_AUTHORITY || ''
export const OIDC_CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID || ''
const APP_ORIGIN = typeof window !== 'undefined' ? window.location.origin : ''
// Land the PKCE callback on /login, NOT the app root: the index route redirects
// `/` → `/login` and would strip the `?code` before it's exchanged. /login
// renders without bouncing, so the code exchange completes.
export const OIDC_REDIRECT_URI = import.meta.env.VITE_OIDC_REDIRECT_URI || `${APP_ORIGIN}/login`
// Where Keycloak returns after RP-initiated logout — back to the app login page,
// not Keycloak's terminal "logged out" page.
export const OIDC_POST_LOGOUT_REDIRECT_URI =
  import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI || `${APP_ORIGIN}/login`

// Geo provider tiers
export type GeoTier = 'cloud-free' | 'cloud-premium' | 'on-premise-basic' | 'on-premise-premium'
export const GEO_TIER: GeoTier = (import.meta.env.VITE_GEO_TIER as GeoTier) || 'cloud-premium'
export const TILE_SERVER_URL = import.meta.env.VITE_TILE_SERVER_URL || ''
export const CESIUM_ION_SERVER = import.meta.env.VITE_CESIUM_ION_SERVER || ''
export const ION_TERRAIN_ASSET_ID = Number(import.meta.env.VITE_ION_TERRAIN_ASSET_ID) || 1
export const ION_BUILDINGS_ASSET_ID = Number(import.meta.env.VITE_ION_BUILDINGS_ASSET_ID) || 96188
